/**
 * Implmentation of Settings Item component
 * 
 * @author - Harsh Tomar
 */

// Dependencies
import React, { ReactChild } from "react";

type Props = {
  label: string;
  children: ReactChild | ReactChild[]
}

export default function SettingsItem(props: Props) {
  return (
    <div className="flex justify-between p-2">
      <div className="flex-1">
        <p className="text-gray-400 font-semibold">{props.label}</p>
        {props.children}
      </div>
    </div>
  )
}